import { PureComponent } from 'react';
import messages from './message';
import Input from 'components/Input';
import Textarea from 'components/Textarea';
import GoogleMaps from 'components/GoogleMaps';
import ActionLink from 'components/ActionLink';
import { IInformationValues } from 'containers/Profile/Content/Information/Information';
import { FieldProps, Field, FormikProps, Formik } from 'formik';
import Icon from 'components/Icon';
import {
  MapWrapper,
  SelectLocationHint,
  InformationForm,
} from 'containers/Profile/Content/Information/styles';
import Button from 'components/Button';
import { IProvider } from 'store/providers/providerTypes';

interface IComponentProps {
  onSave: any;
  saving: boolean;
  provider: IProvider;
}

class GeneralInformation extends PureComponent<IComponentProps> {
  name = '';
  address = '';
  location = {};
  postalCode = '';
  phoneNumber = '';
  description = '';
  workingContext = '';
  username = '';

  saveInformation = (values: IInformationValues) => {
    this.name = values.name;
    this.address = values.address;
    this.location = values.location;
    this.postalCode = values.postalCode;
    this.phoneNumber = values.phoneNumber;
    this.description = values.description;
    this.workingContext = values.workingContext;
    this.username = values.username;
    this.props.onSave();
  };

  render() {
    const { saving, provider } = this.props;

    const initialValues: IInformationValues = {
      name: provider.name || '',
      workingContext: provider.publicProperties?.workingContext || '',
      description: provider.description || '',
      address: provider.address?.text || '',
      location: {
        lat: provider.address?.latitude || null,
        lng: provider.address?.longitude || null,
        mapMarker: true,
      },
      postalCode: provider.address?.postalCode || '',
      phoneNumber: provider.address?.phoneNumber || '',
      username: provider.username || '',
    };
    return (
      <Formik
        onSubmit={this.saveInformation}
        initialValues={initialValues}
        validateOnBlur={false}
        validateOnChange={false}
        render={(formikBag: FormikProps<IInformationValues>) => (
          <InformationForm className="row">
            <div className="col m6 s12">
              <Field
                name="name"
                render={({ field }: FieldProps) => (
                  <Input
                    {...field}
                    type="text"
                    id="name"
                    icon="user"
                    label={messages.name}
                    placeholder={messages.name}
                    autoComplete="off"
                  />
                )}
              />
            </div>
            <div className="col m6 s12">
              <Field
                name="username"
                render={({ field }: FieldProps) => (
                  <Input
                    {...field}
                    type="text"
                    id="username"
                    icon="at-sign"
                    label={messages.username}
                    placeholder={messages.username}
                    autoComplete="off"
                  />
                )}
              />
            </div>
            <div className="col m6 s12">
              <Field
                name="workingContext"
                render={({ field }: FieldProps) => (
                  <Input
                    {...field}
                    type="text"
                    id="workingContext"
                    icon="briefcase"
                    label={messages.subject}
                    placeholder={messages.subject}
                    autoComplete="off"
                  />
                )}
              />
            </div>
            <div className="col m6 s12">
              <Field
                name="postalCode"
                render={({ field }: FieldProps) => (
                  <Input
                    {...field}
                    type="text"
                    id="postalCode"
                    icon="crosshair"
                    label={messages.postalCode}
                    placeholder={messages.postalCode}
                    autoComplete="off"
                  />
                )}
              />
            </div>
            <div className="col m6 s12">
              <Field
                name="phoneNumber"
                render={({ field }: FieldProps) => (
                  <Input
                    {...field}
                    type="text"
                    id="phoneNumber"
                    icon="phone"
                    label={messages.phoneNumber}
                    placeholder={messages.phoneNumber}
                    autoComplete="off"
                  />
                )}
              />
            </div>
            <div className="col m12 s12">
              <Icon type="file-text" />
              <Field
                name="description"
                render={({ field }: FieldProps) => (
                  <Textarea
                    {...field}
                    id="description"
                    label={messages.description}
                    placeholder={messages.description}
                  />
                )}
              />
            </div>
            <div className="col m12 s12">
              <Icon type="map-pin" />
              <Field
                name="address"
                render={({ field }: FieldProps) => (
                  <Textarea
                    {...field}
                    id="address"
                    label={messages.address}
                    placeholder={messages.address}
                  />
                )}
              />
            </div>
            <MapWrapper className="col m12 s12">
              <Icon type="map" />
              <SelectLocationHint>
                {messages.selectTheLocationOnTheMap}
              </SelectLocationHint>
              {!!formikBag.values.location.lat && (
                <span style={{ float: 'left' }}>
                  <ActionLink
                    color="red"
                    onClick={() => {
                      formikBag.setFieldValue('location', {
                        lat: null,
                        lng: null,
                        mapMarker: false,
                      });
                    }}
                  >
                    {messages.removeLocation}
                  </ActionLink>
                </span>
              )}
              <Field
                name="location"
                render={({ form: { values, setFieldValue } }: FieldProps) => (
                  <GoogleMaps
                    lat={values.location.lat}
                    lng={values.location.lng}
                    width="100%"
                    height="300px"
                    marker={values.location.mapMarker}
                    handleChangeLatLng={(lat: number, lng: number) => {
                      setFieldValue('location', {
                        lat,
                        lng,
                        mapMarker: true,
                      });
                    }}
                  />
                )}
              />
            </MapWrapper>
            <div className="col m12 s12">
              <Button
                type="submit"
                color="green"
                style={{ width: '100%' }}
                loading={saving}
              >
                {messages.save}
              </Button>
            </div>
          </InformationForm>
        )}
      />
    );
  }
}

export default GeneralInformation;
